import { ServicePageShell } from "@/components/ServicePageShell";

export default function SecretariatGeneral() {
  return (
    <ServicePageShell
      contentKey="service.sg"
      defaultContent={{
        eyebrow: "Structure administrative",
        title: "Secrétariat Général à la Recherche",
        banner_image: "/media/university-hall.jpg",
        intro: "Le Secrétariat Général à la Recherche pilote la politique scientifique de l'UNISIC. Il coordonne l'ensemble des services et plateformes numériques dédiés à la recherche : bibliothèque, école doctorale, centre d'études en communication, dépôts académiques, archives et revues scientifiques.",
      }}
      missions={[
        "Définir et piloter la politique de recherche de l'université",
        "Coordonner les services académiques rattachés",
        "Développer la science ouverte et la numérisation des archives",
        "Représenter l'université dans les partenariats scientifiques",
      ]}
      sections={[
        {
          title: "Organisation",
          content:
            "Le Secrétariat Général à la Recherche regroupe quatre services : les Bibliothèques et Musées, l'École Doctorale, le CECOM et le Service des Dépôts. Ces services sont interconnectés à travers le portail UNISIC-Recherche.",
        },
        {
          title: "Priorités",
          content: (
            <ul className="list-disc pl-5 space-y-2">
              <li>Numériser et archiver les travaux scientifiques de l'université</li>
              <li>Ouvrir les collections à des moteurs comme Google Scholar, OpenAIRE et BASE</li>
              <li>Renforcer la formation à la méthodologie et à l'intégrité scientifique</li>
              <li>Encourager la publication et la valorisation des résultats de recherche</li>
            </ul>
          ),
        },
      ]}
      actionButtons={[
        { to: "/services/bibliotheque", label: "Service des Bibliothèques et musées" },
        { to: "/services/ecole-doctorale", label: "École Doctorale" },
        { to: "/services/cecom", label: "CECOM" },
      ]}
    />
  );
}
